import Color from '@base/features/game/model/color';

export default class Checker {
  constructor(public color: Color, private position: number) {}

  getColor() {
    return this.color;
  }

  getPosition() {
    return this.position;
  }

  setPosition(pos: number) {
    this.position = pos;
  }

  static fromString(str: string) {
    if (str && str.length >= 2) {
      const col = str.substring(0, 1);
      const pos = str.substring(1);
      return new Checker(Color.fromString(col), parseInt(pos));
    }
  }
}
